module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/lc-0d361ba543e6cd2404e1bff90be28d78.svg";